import React from "react";
import { IconPlus } from "../../common/FormComponent";
import { Container, ImageContainer } from "./index.styles";

type ImageUploadedProps = {
  handleBlobImage: (blob: File) => void;
};

const ImageUploaded: React.FC<ImageUploadedProps> = (props) => {
  const { handleBlobImage } = props;

  const [image, setImage] = React.useState<any>();
  const fileInput = React.useRef<any>();
  const InputClick = () => fileInput.current.click();

  const handleFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fileUploaded = event.currentTarget.files;
    if (!fileUploaded) return;
    const imageAsFile = fileUploaded[0];
    handleBlobImage(imageAsFile);
    let reader = new FileReader();
    reader.readAsDataURL(imageAsFile);
    reader.onload = () => {
      setImage(reader.result);
    };
  };

  return (
    <Container onClick={InputClick}>
      <input
        type="file"
        ref={fileInput}
        accept="image/*"
        onChange={handleFile}
        style={{ display: "none", alignSelf: "center" }}
      />
      {image ? (
        <ImageContainer src={image} alt="product-profile" />
      ) : (
        <IconPlus />
      )}
    </Container>
  );
};

export default ImageUploaded;
